import { useUser } from '@/utils/userContext/UserContext';
import { canAccessPath, canCreateUsers } from './permissions';
import { Role } from '@/utils/models/UserData';

export function usePermissions() {
  const { userData } = useUser();
  
  // Se o usuário está autenticado mas não tem role (usuário antigo), assume OWNER
  const role: Role | undefined = userData?.auth 
    ? (userData.role ?? 'OWNER') 
    : undefined;

  return {
    role,
    canAccess: (path: string) => canAccessPath(role, path),
    canCreateUsers: () => canCreateUsers(role),
    isOwner: role === 'OWNER',
    isOperator: role === 'OPERATOR',
  };
}

